import styled from "styled-components";
import {Text16Arial} from "components/common/Typography";

export const ToastError = styled(Text16Arial)``
export const ToastWarning = styled(Text16Arial)``
export const ToastSuccess = styled(Text16Arial)``
